import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { DnSocialBtnComponent } from './dn-social-btn.component';
import { DnLoaderModule } from '../../dn-loader/dn-loader.module';

@NgModule({
  declarations: [DnSocialBtnComponent],
  imports: [CommonModule, MatButtonModule, DnLoaderModule],
  exports: [DnSocialBtnComponent],
})
export class DnSocialBtnModule {}
